<template>
  <div>
    <template v-if="product">
      <v-toolbar flat color="highlight" dark dense outlined class="sticky-toolbar-breadcrumb">
        <v-toolbar-title>{{$t('product')}}: {{product.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
          <template v-slot:activator="{ on }">
            <v-btn color="white" icon v-on="on">
              <v-icon>fa-info-circle</v-icon>
            </v-btn>
          </template>
          <v-sheet flatwidth="600px">
            <v-list dense>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="white"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>{{$t('info_firelog_solutions')}}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-menu>
        <v-btn
        v-if="$can('update','solutions')"
          color="secondary"
          small
          depressed
          :disabled="product.name == ''"
          @click="save"
        >{{$t('save')}}</v-btn>
      </v-toolbar>

      <v-container fluid>
        <v-card outlined>
          <v-container fluid class="wrapper">
            <div class="solution_name">
              <v-text-field
                outlined
                dense
                :rules="nameRules"
                @input="hasChanges =true"
                :label="$t('name')"
                :counter="50"
                v-model="product.name"
              ></v-text-field>
            </div>
            <div class="solution_active">
              <v-checkbox v-model="product.published" color="primary" :label="$t('active')"></v-checkbox>
            </div>
            <div class="solution_image mx-auto text-center">
              
                <image-uploader
                  id="iu1"
                  :preview="false"
                  capture="environment"
                  :debug="1"
                  :quality="0.8"
                  accept=".jpg, .png"
                  :autoRotate="true"
                  outputFormat="verbose"
                  @input="setSolutionImage"
                >
                  <label for="iu1" slot="upload-label">
                    <template v-if="product.image">
                      <v-img
                        height="145"
                        width="145"
                        
                        aspect-ratio="1"
                        :src="(product.image == null) ? emptyImage : product.image"
                      ></v-img>
                      <a class="primary--text">{{$t('changeImage')}}</a>
                    </template>
                    <v-icon size="150" v-else>add_photo_alternate</v-icon>
                  </label>
                </image-uploader>
              
            </div>
          </v-container>
        </v-card>
      </v-container>
      <savebeforeleave v-on:response="response($event,save)" :dialog="saveDialog"></savebeforeleave>
    </template>
    <v-container fill-height v-else>
      <loading></loading>
    </v-container>
  </div>
</template>

<script>
export default {
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      if(this.$can('update','solutions')){
        this.saveDialog = true;
      this.hasChanges = false;
      this.to = to;
      next(false);
      }
      else{
        next();
      }
    } else {
      next();
    }
  },
  data() {
    return {
      product: null,
      nameRules: [
        v => !!v || `${this.$t("name")} ${this.$t("required")}`,
        v => v.length <= 50 || ""
      ],
      hasChanges: false,
      valid: false,
      valid2: false,
      emptyImage: require("@/assets/empty.png"),
      saveDialog: false,
      to: null
    };
  },
  methods: {
    makeBackButton() {
      this.$store.state.previous = {
        name: "SolutionDetails",
        id: this.$route.params.solutionId,
        breadcrumb: this.$t("solution")
      };
    },
    makeBreadcrumb() {
      if (this.$route.params.solutionName) {
        this.$store.state.breadcrumb = [
          {
            name: this.$t("customsolutions"),
            to: { name: "Solutions" }
          },
          {
            name: this.$route.params.solutionName,
            to: {
              name: "SolutionDetails",
              params: {
                id: this.$route.params.solutionId
              }
            }
          },
          {
            name: this.product.name
          }
        ];
      }
    },
    warning() {
      if (this.hasChanges) {
        this.saveDialog = true;
      }
    },
    response(answer, callback) {
      if (answer) {
        callback();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    setSolutionImage(output) {
      this.product.image = output.dataUrl;
    },

    save() {
      if (this.product) {
        this.$http
          .updateSolution(this.product)
          .then(res => {
            this.$noty.success('<i class="fas fa-check"></i>');
            this.hasChanges = false;
          })
          .catch(err => {
            console.log(err);
            this.$noty.error(this.$t("error"));
          });
      }
    },
    getProductById() {
      this.$http
        .getProductById(this.$route.params.id)
        .then(res => {
          this.product = res.data;
          this.makeBackButton();
          this.makeBreadcrumb();
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.getProductById();
  },
  watch: {
    product: {
      handler(n, o) {
        if (o != null) {
          this.hasChanges = true;
        }
      },
      deep: true
    }
  }
};
</script>
<style scoped>
#iu1 {
  display: none;
}
.list {
  max-height: 350px;
  overflow-y: auto;
}

.wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-areas:
    "solution_name solution_name solution_name solution_image"
    "solution_active solution_active solution_active solution_image";
  grid-gap: 1rem;
}

.solution_name {
  grid-area: solution_name;
}
.solution_active {
  grid-area: solution_active;
}
.solution_image {
  grid-area: solution_image;
}

@media (max-width: 768px) {
  .wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      "solution_image"
      "solution_name"
      "solution_active";
    grid-gap: 1rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/solutions/ProductDetail.vue